import { Grid, Tab, useMediaQuery, useTheme } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { SHOW_LOYALTY_TAB } from "app/appConfig";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  ALL_SERVICES_TAB,
  APPOINTMENT_TAB,
  COMPLANT_TAB,
  CUSTOMER_JOURNEY_TAB,
  FEE_TAB,
  GENERAL_INFOMATION_TAB,
  HIS_ADMIN,
  HIS_BRANCH_MANAGER,
  HIS_CASHIER,
  HIS_DOCTOR,
  HIS_READ_ONLY,
  HIS_SALES_CONSULTANT,
  HISTORY_DIAGNOSIS_TAB,
  HISTORY_TAB,
  IMAGE_TREATMENT_TAB,
  LOYALTY_TAB,
  REGISTER_CARD_TAB,
  REGISTER_PRODUCT_TAB,
  REGISTER_TREATMENT_TAB,
  REVIEW_TAB,
  TREATMENT_TAB,
} from "app/common/LocalConst";
import { checkIsRole } from "app/common/LocalFunction";
import ChatBoxAdviseContainer from "app/EgretLayout/SharedCompoents/ChatBox/ChatBoxAdviseContainer";
import HistoryDiagnosisTabIndex from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/HistoryDiagnosis/HistoryDiagnosisTabIndex";
import HistoryTabsIndex from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/HistoryTab/HistoryIndex";
import CreatePatientPopup from "app/PatientManagement/PatientList/Popup/CreatePatientPopup";
import { pagingPatientAdvise } from "app/services/PatientAdvice";
import { useStore } from "app/stores";
import ImageTreatmentTabIndex from "app/TreatmentManagement/TreamentInfoDetail/ImageTreatmentTab/ImageTreatmentTabIndex";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect } from "react";
import { toast } from "react-toastify";
import CheckInDependentPerson from "../CheckInList/Popup/CheckInDependentPerson";
import PopupDuplicatePatientByPhones from "../CheckInList/Popup/PopupDuplicatePatientByPhones";
import CheckInPopup from "../PatientList/Popup/CheckInPopup";
import CheckOutPopup from "../PatientList/Popup/CheckOutPopup";
import LeadSearchPopup from "../PatientList/Popup/LeadSearchPopup";
import PatientGeneralInfo from "./PatientGeneralInfo";
import AllServicesIndex from "./PatientGeneralTabs/AllServicesTab/AllServicesIndex";
import AppointmentIndex from "./PatientGeneralTabs/AppointmentTab/AppointmentIndex";
import ComplaintIndex from "./PatientGeneralTabs/Complaint/ComplaintIndex";
import CustomerJourneyTabIndex from "./PatientGeneralTabs/CustomerJourneyTab/CustomerJourneyTabIndex";
import FeeIndex from "./PatientGeneralTabs/FeeTab/FeeIndex";
import DebtFeeDetailPopup from "./PatientGeneralTabs/FeeTab/Popup/DebtFeeDetailPopup";
import HistoryChangeRemainPopup from "./PatientGeneralTabs/FeeTab/Tabs/HistoryChangeRemainTab/Popup/HistoryChangeRemainPopup";
import GeneralInfomationIndex from "./PatientGeneralTabs/GeneralInfomationTab/GeneralInfomationBlockIndex";
import LoyaltyPointsIndex from "./PatientGeneralTabs/LoyaltyPointsTab/LoyaltyPointsIndex";
import HistoryPatientPopup from "./PatientGeneralTabs/Popup/HistoryPatientPopup";
import RegisterCardIndex from "./PatientGeneralTabs/RegisterCardTab/RegisterCardIndex";
import RegisterProductAndMedicalIndex from "./PatientGeneralTabs/RegisterProductTab/RegisterProductAndMedicalIndex";
import HistoryStaffRevenuePopup from "./PatientGeneralTabs/RegisterServiceTreatmentPlanTab/Popup/HistoryStaffRevenuePopup";
import RegisterProductTabsIndex from "./PatientGeneralTabs/RegisterServiceTreatmentPlanTab/RegisterServiceTreatmentPlanIndex";
import ReviewFeedbackIndex from "./PatientGeneralTabs/ReviewFeedbackTab/ReviewFeedbackIndex";
import UncompletedServicePopup from "./PatientGeneralTabs/TreatmentTab/Popup/UncompletedServicePopup";
import TreatmentIndex from "./PatientGeneralTabs/TreatmentTab/TreatmentIndex";
import PopupDuplicate from "app/PatientManagement/CheckInList/Popup/PopupDuplicate";

const PatientGeneralIndex = () => {
  const TAB_LIST = [
    {
      tabName: "Thông tin chung",
      content: (
        <>
          <GeneralInfomationIndex />
        </>
      ),
      value: GENERAL_INFOMATION_TAB,
    },
    {
      tabName: "Lịch hẹn",
      content: (
        <>
          <AppointmentIndex />
        </>
      ),
      value: APPOINTMENT_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Check-in & Tư vấn",
      content: (
        <>
          <HistoryTabsIndex />
        </>
      ),
      value: HISTORY_TAB,
    },
    {
      tabName: "Chẩn đoán",
      content: (
        <>
          <HistoryDiagnosisTabIndex />
        </>
      ),
      value: HISTORY_DIAGNOSIS_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Dịch vụ/Liệu trình",
      content: (
        <>
          <RegisterProductTabsIndex />
        </>
      ),
      value: REGISTER_TREATMENT_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Thẻ",
      content: (
        <>
          <RegisterCardIndex />
        </>
      ),
      value: REGISTER_CARD_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Tất cả DV",
      content: (
        <>
          <AllServicesIndex />
        </>
      ),
      value: ALL_SERVICES_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Sản Phẩm",
      content: (
        <>
          <RegisterProductAndMedicalIndex />
        </>
      ),
      value: REGISTER_PRODUCT_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Thanh toán",
      content: (
        <>
          <FeeIndex />
        </>
      ),
      value: FEE_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Điều trị",
      content: (
        <>
          <TreatmentIndex />
        </>
      ),
      value: TREATMENT_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },

    {
      tabName: "Hành trình khách hàng",
      content: (
        <>
          <CustomerJourneyTabIndex />
        </>
      ),
      value: CUSTOMER_JOURNEY_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Khiếu nại",
      content: (
        <>
          <ComplaintIndex />
        </>
      ),
      value: COMPLANT_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    {
      tabName: "Đánh giá & feedback",
      content: (
        <>
          <ReviewFeedbackIndex />
        </>
      ),
      value: REVIEW_TAB,
      role: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
      ],
    },
    // {
    //   tabName: "Ảnh khách hàng",
    //   content: (
    //     <>
    //       <AlbumCustomerTabIndex />
    //     </>
    //   ),
    //   value: 12,
    //   role: [
    //     HIS_ADMIN,
    //     HIS_BRANCH_MANAGER,
    //     HIS_SALES_CONSULTANT,
    //     HIS_CASHIER,
    //     HIS_DOCTOR,
    //   ],
    // },
    {
      tabName: "Tất cả ảnh",
      content: (
        <>
          <ImageTreatmentTabIndex />
        </>
      ),
      value: IMAGE_TREATMENT_TAB,
      // role: [
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_SALES_CONSULTANT,
      //   HIS_CASHIER,
      //   HIS_DOCTOR,
      //   HIS_READ_ONLY
      // ],
    },
    ...[
      SHOW_LOYALTY_TAB
        ? {
          tabName: "Tích điểm",
          content: (
            <>
              <LoyaltyPointsIndex />
            </>
          ),
          value: LOYALTY_TAB,
        }
        : {},
    ],
  ];
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const {
    handleGetPatientOverviewById,
    initialPatient,
    setCurrentTab,
    currentTab,
    handleCloseChatBoxAdvise,
    handleGetItemAdviseById,
    resetStore,
    getCustomerSourceWalkIn,
    openHistoryPatientPopup,
    handleCloseHistoryPatientPopup,
    searchDataHistoryPatient,
    pageDataPatientHistory,
    handleChangeFormSearchHistoryPatient,
    openHistoryStaffRevenuePopup,
    handleCloseHistoryStaffRevenuePopup,
    searchDataHistoryStaffRevenue,
    pageStaffRevenueHistory,
    handleChangeFormSearchHistoryStaffRevenue,
    openInvoiceDebtFeePopup,
    handleCloseInvoiceDebtFeePopup,
    dataInvoiceDebtFee,
  } = useStore().patientManagementStore.patientGeneralStore;
  const {
    openFormCheckIn,
    openFormCreateOrEdit,
    handleCloseFormCheckIn,
    initialCheckIn,
    checkInPatient,
    checkOutPatient,
    openFormCheckOut,
    handleCloseFormCheckOut,
    initialCheckOut,
    handleSearchDuplicateInPersonal,
    openSearchLead,
    handleCloseSearchListPopup,
    leadPatient,
    searchLead,
    handleSelectLeadSelectLeadPersonal,
    openDupPatientByPhones,
    handleCloseDupPatientByPhones,
    duplicatePatients,
    handleSelectDupPatientByPhones,
    openCheckInDependentPersonPopup,
    handleCloseCheckInDependentPersonPopup,
    customerSourceForCompanionDefault,
    initCheckInDependentPerson,
    saveCheckCompanions,

    handleChangeFormSearchDependentPerson,
    openPopupSearchDependentPersonLead,
    handleClosePopupSearchDependentPersonLead,
    searchDuplicatePatient,
    handleSelectDependentPersonLeadPatient,
    openPopupCheckDuplicateDependentPerson,
    handleClosePopupCheckDuplicateDependentPerson,
    handleSelectDuplicateDependentPerson,
    handleChangeFormSearchDependentOnlyLead,
    openCheckPhoneNumber,
    handleClosePopupCheckPhoneNumber,
    textCheckPhoneNumber
  } = useStore().patientManagementStore.patientListStore;

  const { handleChangeFormSearch, searchCheckIn } =
    useStore().patientManagementStore.listCheckInStore;

  const {
    openConfirmClearItemPatientAdvise,
    handleClearItemPatientAdvise,
    handleConfirmAdvise,
    searchAdvise,
    handleChangeFormSearch: handleChangeFormSearchAdvise,
  } = useStore().patientManagementStore.listAdviseStore;

  const {
    openUncompletedServicePopup,
    handleConfirmAssignService,

    handleCloseUncompletedServicePopup,
    searchRegisterService,
    handleOpenConfirmAssign,
    handleChangeFormSearchUncompletedService,
    handleChangeFormSearchService,
    handleCloseConfirmAssign,
    isReadOnlyPopup,
  } = useStore().patientManagementStore.uncompletedRegisterServiceStore;

  const defaultDepartment = useDefaultDepartment();

  const getAdvice = async () => {
    try {
      const { data } = await pagingPatientAdvise({
        patientId,
        pageIndex: 1,
        pageSize: 1,
      });
      if (data?.content?.length > 0) {
        handleGetItemAdviseById(data?.content[0].id); //mặc định phiếu đầu tiên khi vào
      }
    } catch (error) {
      console.error(error);
      toast.error("Lấy thông tin có lỗi!");
    }
  };
  const {
    pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate,
    handleSetSearchObject,
    searchObject,
  } = useStore().patientManagementStore.serviceRequestItemStore;
  async function handleConfirmAssignAndRenewPage() {
    try {
      const result = await handleConfirmAssignService();
      if (!result?.success) return;

      const assignedDay = result.orderDate
        ? moment(result.orderDate).startOf("day").toDate()
        : null;

      const newSO = {
        ...searchObject,
        pageIndex: 1,
        ...(assignedDay
          ? {
              orderDateFrom: assignedDay,
              orderDateTo: assignedDay,
            }
          : {
              orderDateFrom: null,
              orderDateTo: new Date(),
            }),
      };
      handleSetSearchObject(newSO);
      await pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate();
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (patientId) {
      getAdvice();
      getCustomerSourceWalkIn();
    }
    return () => resetStore();
  }, [patientId]);

  const {
    pageHistoryChangeRemainPopup,
    searchHistoryChangeRemainPopup,
    openPopupHistoryChangeRemain,
    handleClosePopupHistoryChangeRemain,
    handleChangeFormSearchPopup,
  } = useStore().feeStore.historyChangeRemainTabStore;

  return (
    <>
      <Grid container spacing={1} className="reception-patient relative">
        <PatientGeneralInfo
          patientId={patientId}
          initialPatient={initialPatient}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />

        <Grid item md={12} style={{ width: "100%" }}>
          <div className="cards-container">
            <TabComponent
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
              patientId={patientId}
              TAB_LIST={TAB_LIST}
            />
            {openFormCreateOrEdit && (
              <CreatePatientPopup
                handleAfterSubmit={() => {
                  setTimeout(() => {
                    handleGetPatientOverviewById(patientId);
                  }, 500);
                }}
                isCloseAfterSubmit
              />
            )}
            {openCheckPhoneNumber && (
              <ConfirmPopup
                open={openCheckPhoneNumber}
                onClose={handleClosePopupCheckPhoneNumber}
                text={textCheckPhoneNumber}
                hideConfirm
                textClose={"Quay lại"}
                title="Thông báo"
              />
            )}
            {openFormCheckIn && (
              <CheckInPopup
                open={openFormCheckIn}
                handleClose={handleCloseFormCheckIn}
                handleSubmit={async (values, { setSubmitting }) => {
                  let { patient } = values;
                  //format lại ảnh
                  // if (patient?.patientAvatarId?.length > 0) {
                  //   patient.patientAvatarId =
                  //     patient?.patientAvatarId[0]?.fileDescription?.id;
                  // }
                  let dataStatus = await checkInPatient(
                    { ...values, patient },
                    {
                      setSubmitting,
                    }
                  );

                  if (dataStatus !== false) {
                    //re call api when check in in tab
                    if (currentTab === GENERAL_INFOMATION_TAB) {
                      setTimeout(() => {
                        handleGetPatientOverviewById(patientId);
                      }, 500);
                    }

                    if (
                      currentTab === APPOINTMENT_TAB ||
                      currentTab === HISTORY_TAB ||
                      currentTab === TREATMENT_TAB
                    ) {
                      handleChangeFormSearch({
                        ...searchCheckIn,
                        departmentId: defaultDepartment,
                        fromDate: new Date(),
                        patientId,
                      });

                      handleChangeFormSearchAdvise({
                        ...searchAdvise,
                        departmentId: defaultDepartment,
                        getItems: true,
                        patientId,
                      });
                    }
                    getAdvice();
                  }
                }}
                initialValues={initialCheckIn}
                handleSearchDuplicateInPersonal={
                  handleSearchDuplicateInPersonal
                }
              />
            )}

            {openCheckInDependentPersonPopup && (
              <CheckInDependentPerson
                open={openCheckInDependentPersonPopup}
                onClose={handleCloseCheckInDependentPersonPopup}
                initCheckInDependentPerson={initCheckInDependentPerson}
                saveCheckCompanions={saveCheckCompanions}
                handleChangeFormSearchDependentPerson={
                  handleChangeFormSearchDependentPerson
                }
                customerSourceForCompanionDefault={
                  customerSourceForCompanionDefault
                }
                handleChangeFormSearchDependentOnlyLead={handleChangeFormSearchDependentOnlyLead}
              />
            )}


            {openPopupSearchDependentPersonLead && (
              <LeadSearchPopup
                open={openPopupSearchDependentPersonLead}
                handleClose={handleClosePopupSearchDependentPersonLead}
                leadPatient={duplicatePatients}
                searchLead={searchDuplicatePatient}
                handleSelect={handleSelectDependentPersonLeadPatient}
                handleChangeFormSearch={handleChangeFormSearchDependentPerson}
              />
            )}

            {openPopupCheckDuplicateDependentPerson && (
              <PopupDuplicate
                open={openPopupCheckDuplicateDependentPerson}
                handleClose={handleClosePopupCheckDuplicateDependentPerson}
                duplicatePatients={duplicatePatients}
                searchCheckIn={searchDuplicatePatient}
                onSelectPatient={handleSelectDuplicateDependentPerson}
                handleChangeFormSearch={handleChangeFormSearchDependentPerson}
              />
            )}

            {openFormCheckOut && (
              <CheckOutPopup
                open={openFormCheckOut}
                handleClose={handleCloseFormCheckOut}
                handleSubmit={async (values, { setSubmitting }) => {
                  let { patient } = values;
                  let dataStatus = await checkOutPatient(
                    { ...values, patient },
                    {
                      setSubmitting,
                    }
                  );
                  if (dataStatus !== false) {
                    if (currentTab === GENERAL_INFOMATION_TAB) {
                      setTimeout(() => {
                        handleGetPatientOverviewById(patientId);
                      }, 500);
                      // getAdvice();
                    }
                  }
                }}
                initialValues={initialCheckOut}
              />
            )}

            {!!openConfirmClearItemPatientAdvise && (
              <ConfirmPopup
                open={!!openConfirmClearItemPatientAdvise}
                onClose={() => handleClearItemPatientAdvise(null)}
                text="Bạn có chắc chắn muốn hủy tư vấn không ?"
                onConfirm={handleConfirmAdvise}
              />
            )}
          </div>
        </Grid>
        {
          <ChatBoxAdviseContainer
            avatar={initialPatient?.avatar}
            displayName={initialPatient?.patientInfo?.displayName}
            handleClose={handleCloseChatBoxAdvise}
          />
        }
        {openHistoryPatientPopup && (
          <HistoryPatientPopup
            open={openHistoryPatientPopup}
            handleClose={handleCloseHistoryPatientPopup}
            searchData={searchDataHistoryPatient}
            pageDataPatientHistory={pageDataPatientHistory}
            handleChangeFormSearch={handleChangeFormSearchHistoryPatient}
          />
        )}
        {openUncompletedServicePopup && (
          <UncompletedServicePopup
            open={openUncompletedServicePopup}
            handleClose={handleCloseUncompletedServicePopup}
            readOnly={isReadOnlyPopup}
            initialValue={searchRegisterService}
            onSubmit={handleChangeFormSearchUncompletedService}
            handleChangeFormSearchService={handleChangeFormSearchService}
            handleConfirmAssignAndRenewPage={handleConfirmAssignAndRenewPage}
            handleGetPatientOverviewById={handleGetPatientOverviewById}
            handleOpenConfirmAssign={handleOpenConfirmAssign}
            handleCloseConfirmAssign={handleCloseConfirmAssign}
          />
        )}

        {openHistoryStaffRevenuePopup && (
          <HistoryStaffRevenuePopup
            open={openHistoryStaffRevenuePopup}
            handleClose={handleCloseHistoryStaffRevenuePopup}
            searchData={searchDataHistoryStaffRevenue}
            pageStaffRevenueHistory={pageStaffRevenueHistory}
            handleChangeFormSearch={handleChangeFormSearchHistoryStaffRevenue}
          />
        )}
        {openSearchLead && (
          <LeadSearchPopup
            open={openSearchLead}
            handleClose={handleCloseSearchListPopup}
            leadPatient={leadPatient}
            searchLead={searchLead}
            handleSelect={handleSelectLeadSelectLeadPersonal}
            handleChangeFormSearch={handleSearchDuplicateInPersonal}
          />
        )}

        {
          <DebtFeeDetailPopup
            open={openInvoiceDebtFeePopup}
            handleClose={handleCloseInvoiceDebtFeePopup}
            initialValue={dataInvoiceDebtFee}
          />
        }
        {openDupPatientByPhones && (
          <PopupDuplicatePatientByPhones
            open={openDupPatientByPhones}
            handleClose={handleCloseDupPatientByPhones}
            duplicatePatients={duplicatePatients}
            onSelectPatient={handleSelectDupPatientByPhones}
          />
        )}

        {openPopupHistoryChangeRemain && (
          <HistoryChangeRemainPopup
            open={openPopupHistoryChangeRemain}
            handleClose={handleClosePopupHistoryChangeRemain}
            searchData={searchHistoryChangeRemainPopup}
            pageData={pageHistoryChangeRemainPopup}
            handleChangeFormSearch={handleChangeFormSearchPopup}
          />
        )}
      </Grid>
    </>
  );
};

const TabComponent = observer(
  ({ currentTab, setCurrentTab, patientId, TAB_LIST }) => {
    const accessibleTabs = TAB_LIST.filter((tab) => {
      if (tab?.role) {
        return tab.role?.some((el) => checkIsRole(el));
      } else {
        return true;
      }
    });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    const finalTabs = isMobile
      ? reorderTabsForMobile(accessibleTabs)
      : [...accessibleTabs];
    return (
      <TabContext value={currentTab}>
        <TabList
          className="tabs-container"
          variant="scrollable"
          scrollButtons="on"
          onChange={(_, newTabIndex) => {
            setCurrentTab(newTabIndex);
          }}
          value={currentTab}
        >
          {finalTabs.map((tab, index) => (
            <Tab
              key={tab.value}
              className={`item-tabs ${tab.value === currentTab ? "item-tabs-active" : ""
                }`}
              label={tab.tabName}
              value={tab.value}
            />
          ))}
        </TabList>
        {finalTabs.map((tab, index) => (
          <TabPanel
            component="section"
            className="p-0"
            key={tab.value}
            value={tab.value}
          >
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    );
  }
);

const reorderTabsForMobile = (tabs) => {
  const result = [...tabs];
  const index2 = result.findIndex((t) => t.value === 2);
  const index5 = result.findIndex((t) => t.value === 5);

  if (index2 !== -1 && index5 !== -1 && index2 < index5) {
    const [tab5] = result.splice(index5, 1);
    result.splice(index2, 0, tab5);
  }

  return result;
};

export default memo(observer(PatientGeneralIndex));
